export const UPDATE_CONFIGURATION = 'UPDATE_CONFIGURATION';
export const UPDATE_LEAD = 'UPDATE_LEAD';
export const ADD_ELEVATOR = 'ADD_ELEVATOR';
export const UPDATE_ELEVATOR_DATA = 'UPDATE_ELEVATOR_DATA';
export const REMOVE_ELEVATOR = 'REMOVE_ELEVATOR';
export const SET_ELEVATOR_INDEX = 'SET_ELEVATOR_INDEX';
export const RESET = 'RESET';
export const SET_MODE = 'SET_MODE';